import { Stack } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { Loader } from '@/components/layout/loading';
import { useDAL } from '@/contexts/useDAL';

import { AwsSnapshotList } from './awsSnapshotList';
import { AzureRestorePointsList } from './azureRestorePointsList';
interface OtherSnapshotsListProps {
  resource: InventoryResource;
  selectedDate: Date;
}

export const OtherSnapshotsList = ({
  selectedDate,
  resource,
}: OtherSnapshotsListProps) => {
  const dal = useDAL();
  const { data: providerSnapshots, isLoading } = dal.convert.listCloudSnapshots(
    resource.id,
    selectedDate
  );
  if (isLoading) {
    return (
      <Stack key='loader' marginY='40px'>
        <Loader />
      </Stack>
    );
  }

  return resource.cloudProvider === Provider.Aws ? (
    <AwsSnapshotList
      resource={resource}
      snapshots={providerSnapshots?.snapshotsPerVolume || []}
    />
  ) : (
    <AzureRestorePointsList
      resource={resource}
      restorePoints={providerSnapshots?.restorePoints || []}
    />
  );
};
